module.exports = __webpack_public_path__ + "img/banner-tc1.448958a6.jpg";